// i18n area 'common' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da common.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/common.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './common'

export const enGB: DeepPartial<typeof enUS> = {
  search: {
    kind: {
      catalog: 'Catalogue'
    }
  },
  stub: {
    sectionSummary_catalogs: 'The home of the cluster\'s file artefacts: ISO images, CT and VM templates and OCI archives, organised in catalogues.',
    containersApps: 'Containerised applications are on the roadmap — this area will host them.'
  },
  home: {
    reason: {
      'license-absent': 'no licence — new VMs cannot start',
      'license-expired': 'licence expired — new VMs cannot start',
      'license-exceeded': 'licence limit exceeded — new VMs cannot start'
    }
  }
}
